import { translateFilters } from './translateFilters'

export const isKeyFilterChange = (keysFilters, item) => {
  const translattedKeyFilters = keysFilters.map((key) => {
    return translateFilters(key)
  })

  return translattedKeyFilters.includes(item)
}
